<template>
  <v-layout v-if="!shift.tradePending" row align-end>
    <v-flex grow>
      <v-textarea
        label="Reason for Trade"
        v-model="tradeReason"
        hide-details
      >
      </v-textarea>
    </v-flex>
    <v-flex shrink>
      <v-btn @click="submitTradeRequest" color="grey darken-2" class="mb-0 white--text">
        <v-icon left>
          sync
        </v-icon>
        Submit Trade Request
      </v-btn>
    </v-flex>
  </v-layout>
  <v-layout v-else column>
    <v-flex>
      <div v-if="shift.tradeAcceptUserId == user.id">
        <p>You've offered to take this shift but the trade needs to be approved by a manager. Once approved, the shift will be assigned to you.</p>
      </div>
      <div v-if="shift.userId == user.id">
        <div v-if="shift.tradeApprovalPending">
          <p>Another employee has offered to take this shift!</p>
          <p> The trade is waiting for manager approval. Once approved, this shift will be assigned to the other employee.</p>
        </div>
        <div v-else>
          <p>This shift is currently on offer for trade, but you are still expected to work it unless someone else picks it up.</p>
          <p>If you'd like to take it off of trade, use the button below.</p>
          <v-btn @click="revokeTrade" color="grey darken-2" class="white--text">
            <v-icon left>
              sync
            </v-icon>
            Revoke Trade Offer
          </v-btn>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import PunchRow from '@/components/calendar/punch.vue'

export default {
  props: [
    'shift',
    'user',
  ],

  components: {
    PunchRow,
  },

  data() {
    return {
      decisionApiCallPending: false,
      tradeReason: null,
    }
  },

  computed: {
    ...mapGetters('timeclock', [
      'sortedPunches',
    ]),
  },

  methods: {
    revokeTrade () {
      this.$store.dispatch('shifts/revokeTrade', this.shift.id)
    },
    submitTradeRequest () {
      this.$store.dispatch('shifts/requestTrade', {
        shiftId: this.shift.id,
        tradeReason: this.tradeReason,
      })
    },
  },

}
</script>
